import { useEffect, useState } from 'react';
import { LABEL_SWAP_DURATION } from '../styled';
const VISIBLE_TIMER = 2400;
/**
 * Cycles through `labels` while `active`, fading the current one out for
 * `LABEL_SWAP_DURATION` before swapping in the next.
 */
export function useRotatingLabel(labels, active) {
    const [index, setIndex] = useState(0);
    const [swapping, setSwapping] = useState(false);
    useEffect(() => {
        if (!active || labels.length <= 1) {
            return undefined;
        }
        let swapTimeout;
        const interval = setInterval(() => {
            setSwapping(true);
            swapTimeout = setTimeout(() => {
                setIndex((i) => (i + 1) % labels.length);
                setSwapping(false);
            }, LABEL_SWAP_DURATION);
        }, VISIBLE_TIMER);
        return () => {
            clearInterval(interval);
            clearTimeout(swapTimeout);
            setSwapping(false);
        };
    }, [active, labels.length]);
    return { label: labels[index % labels.length], swapping };
}
